import { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import { trapCounts } from "./trapCards";
import CardImg from "../../../../components/CardImg";

/**
 * The Trap video card overlay in the reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container >
 *     .row.row5 (A / B with .player-count totals) + 7 × .row.row5 (col-6 card A[i], col-6 card B[i]).
 * Hidden while cards[0] is a back ("1"); the shuffle handle toggles it.
 */
export default function TrapCardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || !String(card).length) return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";
  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const { a, b } = trapCounts(cards);
  const cell = (c) => (c !== "1" ? (
    <span>
      <CardImg src={getCardImage(c)} alt="" />
    </span>
  ) : null);

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div className="row row5">
          <div className="col-6 text-center">
            <span>
              <b>A</b> <div className="player-count">{a}</div>
            </span>
          </div>{" "}
          <div className="col-6 text-center">
            <span>
              <b>B</b> <div className="player-count">{b}</div>
            </span>
          </div>
        </div>{" "}
        {Array.from({ length: 7 }, (_, i) => (
          <div key={i} className="row row5">
            <div className="col-6">{cell(cards[2 * i])}</div> <div className="col-6">{cell(cards[2 * i + 1])}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
